'use client'

import { createLink } from '@gluestack-ui/link'
import type { VariantProps } from '@gluestack-ui/nativewind-utils'
import { tva } from '@gluestack-ui/nativewind-utils/tva'
import { withStyleContext } from '@gluestack-ui/nativewind-utils/withStyleContext'
import { cssInterop } from 'nativewind'
import React from 'react'
import { Pressable, Text } from 'react-native'

export const UILink = createLink({
  Root: withStyleContext(Pressable),
  Text: Text
})

cssInterop(UILink, { className: 'style' })
cssInterop(UILink.Text, { className: 'style' })

const linkStyle = tva({
  base: 'group/link data-[disabled=true]:opacity-4 web:outline-0 data-[focus-visible=true]:web:outline-0 data-[focus-visible=true]:web:ring-2 data-[focus-visible=true]:web:ring-indicator-primary data-[disabled=true]:web:cursor-not-allowed'
})

const linkTextStyle = tva({
  base: 'web:tracking-sm web:display-inline web:margin-0 web:padding-0 web:position-relative web:word-wrap-break-word font-poppinsRegular text-info-700 underline web:my-0 web:box-border web:list-none web:whitespace-pre-wrap web:border-0 web:bg-transparent web:text-start web:font-sans data-[hover=true]:text-info-600 data-[hover=true]:no-underline data-[active=true]:text-info-700',

  variants: {
    isTruncated: {
      true: 'web:truncate'
    },
    bold: {
      true: 'font-poppinsBold'
    },
    underline: {
      true: 'underline'
    },
    strikeThrough: {
      true: 'line-through'
    },
    size: {
      '2xs': 'text-2xs',
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
      '6xl': 'text-6xl'
    },
    sub: {
      true: 'text-xs'
    },
    italic: {
      true: 'italic'
    },
    highlight: {
      true: 'bg-yellow-500'
    }
  }
})

type ILinkProps = React.ComponentProps<typeof UILink> & VariantProps<typeof linkStyle> & { className?: string }

const Link = React.forwardRef<React.ComponentRef<typeof UILink>, ILinkProps>(({ className, ...props }, ref) => {
  return (
    <UILink
      ref={ref}
      {...props}
      className={linkStyle({ class: className })}
    />
  )
})

type ILinkTextProps = React.ComponentProps<typeof UILink.Text> &
  VariantProps<typeof linkTextStyle> & { className?: string }

const LinkText = React.forwardRef<React.ComponentRef<typeof UILink.Text>, ILinkTextProps>(
  ({ className, size = 'md', ...props }, ref) => {
    return (
      <UILink.Text
        // maxFontSizeMultiplier={1.5}
        // minimumFontScale={0.5}
        ref={ref}
        {...props}
        className={linkTextStyle({
          class: className,
          size
        })}
      />
    )
  }
)

Link.displayName = 'Link'
LinkText.displayName = 'LinkText'

export { Link, LinkText }
